module.exports = __webpack_public_path__ + "img/editor_weibo.0ef015c9.png";